/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Mere information",
  "CookieMessage.old.text":
    "For at webshoppen fungerer optimalt, anvender vi cookies. Se vores cookie politik.",
  "CookieMessage.link": "Accepter cookies",
  "CookieMessage.more_information": "Læs mere om Kramp cookies",
  "CookieMessage.return": "Tilbage",
  "CookieMessage.intro.body":
    "Disse cookies er placeret af Kramp såvel som af tredjepart. Vi behandler naturligvis dine data meget omhyggeligt. Ved at klikke på Accepter cookies nedenfor, godkender du at vi må bruge disse cookies. Ved at acceptere disse cookies, er du sikker på at webshoppen fungerer optimalt. Eksempler på hvad cookies anvendes til, er følgende:",
  "CookieMessage.intro.list.1": "Automatisk login til Min konto",
  "CookieMessage.intro.list.2":
    "Analyse af brugeradfærd for at forbedre webshoppen",
  "CookieMessage.intro.list.3":
    "Skabe personlige kundeprofiler, som tillader os at vise personaliseret information og markedsføring.",
  "CookieMessage.intro.extra":
    'Hvis du ikke ønsker at acceptere alle cookies, kan du ændre dette i <a>indstillinger</a>. For mere information, læse vores <a href="{legalLink}">privatliv og cookiespolitik</a>',
  "CookieMessage.intro.title": "Kramp anvender cookies",
  "CookieMessage.settings.body":
    "Du kan vælge mellem 3 cookies-indstillinger. Standard-indstilling giver os mulighed for, at give dig den bedste oplevelse på webshoppen.",
  "CookieMessage.settings.standard.title": "Standard (mest populære):",
  "CookieMessage.settings.standard.body":
    "Cookies bruges til login, bestilling, analyse, personaliseret information, sociale medier og cookies fra tredjepart.",
  "CookieMessage.settings.restricted.title": "Begrænset:",
  "CookieMessage.settings.restricted.body":
    "Cookies anvendes ved login, ordre, analyse samt personaliseret information.",
  "CookieMessage.settings.highly_restricted.title": "Meget begrænset:",
  "CookieMessage.settings.highly_restricted.body":
    "Du tillader et minimum af cookies. Anvendes kun ved login, ordreafgivelse og tillades kun for at webshoppen fungerer i et rimeligt omfang.",
  "CookieMessage.settings.options.title": "Her er hvad vi gør:",
  "CookieMessage.settings.option.1":
    "Bruger cookies for at sikre, at siden fungerer",
  "CookieMessage.settings.option.2": "Undersøge brugeradfærd",
  "CookieMessage.settings.option.3": "Tracke personlige statistikker",
  "CookieMessage.settings.option.4":
    "Vise informationer, der kan have din interesse",
  "CookieMessage.settings.option.5":
    "Bruger information til vores markedsføring",
  "CookieMessage.settings.option.6": "Tracke anonyme statistikker",
  "CookieMessage.settings.option.7": "Del dine personlige informationer",
  "CookieMessage.settings.title": "Cookie indstillinger",
  "CookiePage.url": "privatliv-cookie-politik",
};
